// extracted by mini-css-extract-plugin
module.exports = {"price":"AddOn_price__GPCgQ"};